import { render, staticRenderFns } from "./border.vue?vue&type=template&id=c5f3fcf8&scoped=true&lang=pug"
import script from "./border.vue?vue&type=script&lang=ts"
export * from "./border.vue?vue&type=script&lang=ts"
import style0 from "./border.vue?vue&type=style&index=0&id=c5f3fcf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f3fcf8",
  null
  
)

export default component.exports